/* Masszeile der Halterung (Snippet cs-masse.liquid): tauscht beim
   Variantenwechsel den angezeigten Wert aus der eingebetteten JSON-Map
   (variant_id -> fertig formatierter String). Progressive Enhancement:
   der Initialzustand kommt serverseitig aus Liquid. */
if (!customElements.get('cs-masse')) {
  customElements.define(
    'cs-masse',
    class CsMasse extends HTMLElement {
      connectedCallback() {
        this.valueEl = this.querySelector('[data-cs-masse-value]');
        const mapEl = this.querySelector('[data-cs-masse-map]');
        try {
          this.map = mapEl ? JSON.parse(mapEl.textContent) : {};
        } catch (e) {
          this.map = {};
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!this.belongsToUs(event.data)) return;
            const variant = event.data.variant;
            const disp = variant ? this.map[variant.id] : null;
            if (disp) {
              this.valueEl.textContent = disp;
              this.hidden = false;
            } else {
              this.hidden = true;
            }
          });
        }
      }

      /* Das Event nennt nur eine sectionId. Die aus Liquid gesetzte
         data-section-id passt im Shop, weicht im Theme-Editor und bei
         Quick-Add aber ab (dort publiziert Dawn data-original-section).
         Deshalb gegen alle IDs des eigenen product-info-Vorfahren pruefen
         und zusaetzlich akzeptieren, wenn die Variante zu diesem Produkt
         gehoert - fremde Varianten stehen nie in unserer Map. */
      belongsToUs(data) {
        const pi = this.closest('product-info');
        const ids = [this.dataset.sectionId, pi && pi.dataset.section, pi && pi.dataset.originalSection];
        if (ids.filter(Boolean).indexOf(data.sectionId) !== -1) return true;
        return !!(data.variant && Object.prototype.hasOwnProperty.call(this.map, data.variant.id));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
